module.exports = __webpack_public_path__ + "static/media/spinner_white.bdd76160.gif";